export default __webpack_public_path__ + "static/media/privacy.7cccd050.jpg";